import { isBoardEditorPath } from '../libs/boardUrls';

export type BarMode = 'generate' | 'editor' | null;

export interface BarRouteState {
  activeMode: BarMode;
  concepts2Id: string | null;
  isConcepts2Route: boolean;
  isHomeLayout: boolean;
  isProjectRoute: boolean;
  isSharePage: boolean;
  showModeButtons: boolean;
}

const LEGACY_CONCEPT_ROUTE = /\/concepts\/(?!new$)[^/]+$/;
const IMAGE_ROUTE = /\/image\/[^/]+$/;
const CONCEPTS2_MODE_ROUTE = /\/concepts2\/(?!editor\/new)[^/]+/;
const CONCEPTS2_ID_ROUTE = /\/concepts2\/(?:editor\/)?([^/]+)/;

export const getBarRouteState = (pathname: string): BarRouteState => {
  const isSharePage = pathname.includes('/concepts2/share/');
  const concepts2Match = pathname.match(CONCEPTS2_ID_ROUTE);
  const concepts2Id = concepts2Match?.[1] && concepts2Match[1] !== 'new' ? concepts2Match[1] : null;

  const activeMode: BarMode =
    (pathname.startsWith('/home/concepts') && !pathname.startsWith('/home/concepts2')) ||
    pathname.startsWith('/home/chat') ||
    (pathname.startsWith('/home/concepts2/') && !pathname.includes('/editor/'))
      ? 'generate'
      : pathname.startsWith('/image') || pathname.includes('/concepts2/editor/')
        ? 'editor'
        : null;

  return {
    activeMode,
    concepts2Id,
    isConcepts2Route: pathname.includes('/concepts2/'),
    isHomeLayout: pathname.startsWith('/home'),
    isProjectRoute: isBoardEditorPath(pathname),
    isSharePage,
    showModeButtons:
      !isSharePage &&
      (LEGACY_CONCEPT_ROUTE.test(pathname) || IMAGE_ROUTE.test(pathname) || CONCEPTS2_MODE_ROUTE.test(pathname)),
  };
};
